export { ConfluenceTemplateDetailsPageTemplate } from "./confluence-template-details-page.template";
export { ConfluenceTemplatesPageTemplate } from "./confluence-templates-page.template";
export { ConfluenceTemplateCategoryPageTemplate } from "./confluence-template-category-page.template";
export { ConfluenceTemplateSearchPageTemplate } from "./confluence-template-search-page.template";
export { ConfluenceTemplatesCollectionDetailsPageTemplate } from "./confluence-template-collection-details-page.template";
